var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge-container"},[_c('span',{class:['univers-badge', _vm.getUniversClass(_vm.univers)]},[_vm._v(" "+_vm._s(_vm.displayUnivers)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }